<template>
    <CHeader data-aos-easing="linear" data-aos-duration="1500" id="el" class="navbars">
        <CHeaderBrand class="mx-auto mt-2" to="/index">
            <img src="../assets/img/logo.png" height="32" class="m-2" alt="Interviewrr.ai company logo"/> 
        </CHeaderBrand>
    
        <CDropdown color="light" class="m-2 d-sm-flex d-lg-none" :caret="false">
            <template #toggler-content>
                                  <CIcon name="cil-justify-center" />
</template>
       
        <CDropdownItem href="/"
          >Home</CDropdownItem
        >

        <CDropdownItem to=""
          >About</CDropdownItem
        >

        <CDropdownItem to="Detection"
          >Detection</CDropdownItem
        >

        <CDropdownItem to=""
          >Blog</CDropdownItem
        >

        <CDropdownItem to="StatisticAndAnalysis"
          >Dashboard</CDropdownItem
        >

        
      

        <CDropdownItem to=""
          >Contact</CDropdownItem
        >

      

      </CDropdown>
  
      <CHeaderNav class="d-md-down-none mr-auto bg-menu m-2">
        <CHeaderNavItem class="px-3">
          <CHeaderNavLink
            style="
            color: #171717;font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;
            "
            to="Home"
            active-class="bg-272835 text-white" 
          >
            Home
          </CHeaderNavLink>
        </CHeaderNavItem>

        <CHeaderNavItem class="px-3">
          <CHeaderNavLink
            style="
               color: #171717;font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;
            "
            to=""
            active-class="bg-272835 text-white" 
          >
           About
          </CHeaderNavLink>
        </CHeaderNavItem>

        <CHeaderNavItem class="px-3">
          <CHeaderNavLink
            style="
               color: #171717;font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;
            "
            to="Detection"
            active-class="bg-272835 text-white" 
          >
           Detection
          </CHeaderNavLink>
        </CHeaderNavItem>


       
      

       

       

      

        <CHeaderNavItem class="px-3">
          <CHeaderNavLink
            style="
              color: #171717;font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;
            "
            to=""
            active-class="bg-272835 text-white" 
          >
          How it Works
          </CHeaderNavLink>
        </CHeaderNavItem>

        <CHeaderNavItem class="px-3">
          <CHeaderNavLink
            style="
              color: #171717;font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;
            "
            to=""
            active-class="bg-272835 text-white" 
          >
          Blog
          </CHeaderNavLink>
        </CHeaderNavItem>

        <CHeaderNavItem class="px-3">
          <CHeaderNavLink
            style="
              color: #171717;font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;
            "
            to=""
            active-class="bg-272835 text-white" 
          >
          Contact
          </CHeaderNavLink>
        </CHeaderNavItem>

        <CHeaderNavItem class="px-3">
          <CHeaderNavLink
            style="
              color: #171717;font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;
            "
            to="StatisticAndAnalysis"
            active-class="bg-272835 text-white" 
          >
          Dashboard
          </CHeaderNavLink>
        </CHeaderNavItem>



      </CHeaderNav>
    </CHeader>
  </template>
      
<script>
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";

export default {
    name: "TheHeader",
    components: {
        TheHeaderDropdownAccnt,
    },
    data() {
        return {
          Name: "",
          user: {}
        }
    },
    async mounted() {

         //this.GetInfoUser();

        // if (localStorage.getItem("reloaded")) {
        //     // The page was just reloaded. Clear the value from local storage
        //     // so that it will reload the next time this page is visited.
        //     localStorage.removeItem("reloaded");
        // } else {
        //     // Set a flag so that we know not to reload the page twice.
        //     localStorage.setItem("reloaded", "1");
        //     location.reload();
        // }
    },
    methods: {


        GoToLogin() {
            this.router.push("Login");
        },
      
    },
};
</script>

<style scoped>

</style>
  
  
  